<div class="importContainer">
  <span *ngIf="data.successMessage!=null" class="successMessage">{{data.successMessage}}</span><br>
  <span *ngIf="data?.sets?.length<1" class="error">You don't have any sets saved for this schedule.</span>
  <div class="rankingSet" *ngFor="let set of data.sets">
    <div class="left">
      {{set.name}}
    </div>
   <div class="rankingright">
    <button mat-button color="accent" class="resetdefault" *ngIf="set.is_default ==1" [disabled]="set.is_default==0?true:false" [ngClass]="set.is_default==0?'active':''" (click)="unSetDefaultRanking(set)">Reset Default</button> 
    <button class="setasdefault" *ngIf="set.is_default==0" [disabled]="set.is_default==1?true:false" [ngClass]="set.is_default==1?'active':''" (click)="setAsDefault(set)">Set Default</button> 
    <button mat-raised-button class="import" (click)="sendSet(set)">Import</button>
    <a class="remove-ranking red" (click)="removeRanking(set)"><i class="far fa-trash-alt"></i></a>
    </div>
  </div>
</div>